export const missingTippy = 'Using the attachment feature of Shepherd requires the Tippy.js library';
